export default __webpack_public_path__ + "static/media/AgentProfiling.c6936f5b.svg";